module.exports = __webpack_public_path__ + "img/gt.73799f20.png";